import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn,actionReportColumn, perfixLineColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P220List({ dataTable, setLocation }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    const [globalFilter, setGlobalFilter] = useState(null);


    const actionDetail = (rowData) =>{
        setLocation(rowData)
    }

    const onRowClick = (rowData) =>{
            setLocation(rowData.data)
    }
    

    const header = (
        <div className="table-header">
            <div></div>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" placeholder="คำค้น" className="btn-responsive" onInput={(e) => setGlobalFilter(e.target.value)} />
            </span>
        </div>
    );

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    header={header}
                    onRowClick={onRowClick}
                    globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="requestLocation" header="บริเวณ" body={(e) => normalColumn(e, "requestLocation", "บริเวณ")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="operateDate" header="วันที่ปฏิบัติงาน" body={(e) => normalColumn(e, "operateDate", "วันที่ปฏิบัติงาน")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="requestDesc" header="ลักษณะงาน" body={(e) => perfixLineColumn(e, "requestDesc", "ลักษณะงาน")} style={{ textAlign: "center"}} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="requestQuantity" header="ปริมาณที่ขอ" body={(e) => normalColumn(e, "requestQuantity", "ปริมาณที่ขอ")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="operateQuantity" header="ปริมาณที่ทำ" body={(e) => normalColumn(e, "operateQuantity", "ปริมาณที่ทำ")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="requestNo" header="เลขที่ใบแจ้งฯ" body={(e) => normalColumn(e, "requestNo", "เลขที่ใบแจ้งฯ")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="supervisor" header="ผู้ตรวจงาน" body={(e) => normalColumn(e, "supervisor", "ผู้ตรวจงาน")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="inspectWorkerDetail" header="ความเห็นแรงงาน" body={(e) => normalColumn(e, "inspectWorkerDetail", "ความเห็นแรงงาน")} style={{ width: "11%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="inspectEquipmentDetail" header="ความเห็นเครื่องจักร/เครื่องมือ" body={(e) => normalColumn(e, "inspectEquipmentDetail", "ความเห็นเครื่องจักร/เครื่องมือ")} style={{ width: "11%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="orderDetail" header="การสั่งการเฉพาะอย่าง" body={(e) => normalColumn(e, "orderDetail", "การสั่งการเฉพาะอย่าง")} style={{ textAlign: "center", width: "11%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column header="" body={(e) => actionReportColumn(e, actionDetail,'รายละเอียด')} style={{ textAlign: "center", width: "6%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                </DataTable>
            </div>
        </div>
    );
}
